export default "__VITE_ASSET__CqRdEK9J__"